import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { formatRUT } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { SupportLine } from "@/components/SupportContact";

export default function ForgotPassword() {
  const [rut, setRut] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { rut });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md fade-in">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <ShieldCheck className="w-7 h-7 text-primary" />
          <span className="font-heading font-extrabold text-xl text-primary">EIM Becas</span>
        </div>
        <div className="bg-white rounded-2xl border border-border p-8">
          {sent ? (
            <div className="text-center space-y-4">
              <MailCheck className="w-12 h-12 text-emerald-600 mx-auto" />
              <h1 className="text-2xl font-bold">Revisa tu email</h1>
              <p className="text-muted-foreground">Si el RUT está registrado, enviamos un enlace para restablecer tu contraseña.</p>
              <Link to="/ingresar" className="text-primary font-semibold hover:underline inline-block">Volver a ingresar</Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <h1 className="text-2xl font-bold">Recuperar contraseña</h1>
              <p className="text-muted-foreground">Ingresa tu RUT y te enviaremos un enlace a tu email.</p>
              <div>
                <Label className="text-sm font-semibold uppercase tracking-wide text-slate-600">RUT</Label>
                <Input data-testid="input-rut" className="h-14 text-lg rounded-xl mt-2" value={rut}
                  onChange={(e) => setRut(formatRUT(e.target.value))} required />
              </div>
              <Button type="submit" disabled={loading} className="btn-lift w-full h-14 text-lg rounded-xl" data-testid="btn-forgot-submit">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Enviar enlace"}
              </Button>
              <Link to="/ingresar" className="block text-center text-sm text-primary font-semibold hover:underline">Volver</Link>
            </form>
          )}
        </div>
        <SupportLine className="mt-6" />
      </div>
    </div>
  );
}
